<template>
    <div class="field input_field" :class="isHasError ? 'has_error' : ''">
				<div class="field_label__wrapper">
            <label class="field_label" :class="isFieldRequired || isRequired ? 'req' : ''">{{ label }}</label>
						<template v-if="isDescriptionHtml">
                <p class="field_description" v-if="description" v-html="description"></p>
						</template>
						<template v-else>
                <p class="field_description" v-if="description">{{ description }}</p>
						</template>
				</div>

				<p class="errorText" v-if="errorText">{{ errorText }}</p>
        <input
                :disabled="isDataUpdated"
                :class="isFieldHasError ? 'has_errors':''"
                name="name"
                type="text"
                :value="modelValue"
                :placeholder="placeholder"
                @change="$emit('update:modelValue', $event.target.value); $emit('onChange', $event.target.value);"
                v-bind="$attrs"
        />
        <slot name="footer"></slot>
    </div>
</template>

<script>
export default {
  name: "BaseInput3.vue",
  inheritAttrs: false,
  data() {
    return {}
  },
  mounted() {},
  props: [
    'label',
    'modelValue',
    'description',
		'isDescriptionHtml',
    'rules',
    'objectKey',//Нужен для валидации
    'isFormSubmitted',
    'isDataUpdated',
    'placeholder',
    'isRequired',
		'isHasError',
		'errorText'
  ],
  methods: {},
  computed: {
    isFieldRequired() {
      if (typeof this.$parent.isFieldRequired === 'function') {
        return this.$parent.isFieldRequired(this.objectKey);
      } else {
        return false;
      }
    },
    isFieldHasError() {
      return !!(this.isFieldRequired && this.isFormSubmitted && (this.modelValue === undefined || this.modelValue.length === 0));
    }
  }

}
</script>

<style scoped>
.field_label {
    margin-bottom: 15px;
}

.field_description {
    font-size: 16px;
    color: rgba(34, 34, 34, 0.5);
    margin-bottom: 10px;
}
.field_label__wrapper {
		flex-grow: 1;
}
.field.has_error input {
	border: 1px solid red;
}
.errorText {color: red}
</style>